

export class SmsAllocationCompanyDetailsAddInput implements ISmsAllocationCompanyDetailsAddInput {
    /** The auto-generated id of the company details master */
    companyDetailsId!: number;

    constructor(data?: ISmsAllocationCompanyDetailsAddInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyDetailsId = _data["companyDetailsId"];
        }
    }

    static fromJS(data: any): SmsAllocationCompanyDetailsAddInput {
        data = typeof data === 'object' ? data : {};
        let result = new SmsAllocationCompanyDetailsAddInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyDetailsId"] = this.companyDetailsId;
        return data; 
    }
}

export interface ISmsAllocationCompanyDetailsAddInput {
    /** The auto-generated id of the company details master */
    companyDetailsId: number;
}

